import React, { useEffect, useState, useRef } from 'react';
import Axios from '../../config/axios';
import { Drawer, Card, message } from 'antd';
import { getGroupedReports, downloadReportByName } from '../../services/ReportsService';
import { Fragment } from 'react';
import { toast, confirm } from '@rickylandino/react-messages';
import RunReportModal from '../Helpers/RunReportModal';
import { componentMap } from '../Helpers/Widgets';

function ReportsSlider(props) {
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const listRef = useRef();

    const [state, setState] = useState({
        showReportCriteriaModal: false,
        showRunReportModal: false,
        selectedReport: null
    });

    const [modalInfo, setModalInfo] = useState({
        show: false
    });

    const [height, setHeight] = useState({
        triggered: false,
        value: ''
    });

    const [reportsToDisplay, setReportsToDisplay] = useState({});
    const [biggestGroup, setBiggestGroup] = useState(null);
    const [selectedReport, setSelectedReport] = useState({});

    useEffect(() => {
        //console.log(props.widgets);

        getGroupedReports(userInfo.userId, userInfo.jobShopDivision).then(data => {
            if (data) {
                setReportsToDisplay(data);

                if (Object.keys(data).length == 0) {
                    setHeight({
                        ...height,
                        triggered: true
                    });
                }

                var size = 0;
                var bg = null;
                for (const property in data) {
                    if (data[property].length > size) {
                        size = data[property].length;
                        bg = property;
                    }
                }

                setBiggestGroup(bg);
            } else {
                toast.error("Something went wrong");
            }
        });
    }, []);

    useEffect(() => {

        setTimeout(() => getListSize(), 500);

        window.addEventListener("resize", getListSize);
    }, [listRef]);

    useEffect(() => {
        if (props.showModal) {
            setModalInfo({
                show: props.showModal
            });
        }
    }, [props.showModal]);

    const getListSize = () => {
        const newHeight = listRef?.current?.clientHeight;
        if (newHeight) {
            setHeight({
                triggered: true,
                value: newHeight
            });
        }
    };

    function handleClose() {
        setModalInfo({
            show: false
        });

        setState({
            ...state,
            showReportCriteriaModal: false
        });

        setTimeout(() => { props.hideModal(); }, 1000);
    }

    function hideRunReportModal() {
        setTimeout(() => {
            setState({
                ...state,
                showRunReportModal: false,
                showReportCriteriaModal: true
            });
        }, 1000);
    }

    function handleReportRequest(report) {
        var selectedWidget;
        var selectedWidgetId;
        var selectedWidgetName
        var selectedWidgetTitle;

        //First check to see if a widget is being requested rather than a 'real' report
        componentMap.forEach((w, idx) => {
            if (w.WidgetTitle === report.reportName) {
                selectedWidget = w.WidgetComponent;
                selectedWidgetId = w.WidgetName;
                selectedWidgetTitle = w.WidgetTitle;
            }
        });

        if (selectedWidget !== undefined) {
            setTimeout(() => props.loadSelectedWidget(selectedWidgetId, selectedWidgetTitle), 500);
        }
        else {
            setSelectedReport(report);

            setState({
                ...state,
                showRunReportModal: true,
            });
        }
    }

    //function handleReportRequest(e, report) {
    //    console.log(report);

    //    e.preventDefault();

    //    setState({
    //        ...state,
    //        selectedReport: e.target.id,
    //        selectedReportId: e.target.value,
    //        showRunReportModal: true,
    //    });
    //}

    function downloadReport(reportName, reportOption, rptDropDown1Value, selectedShow1, selectedShow2) {
        const key = "downloademailtemplate";
        message.loading({
            content: 'Report generation in progress...',
            key,
            duration: 0,
            //style: {
            //    position: "fixed",
            //    bottom: 0,
            //    left: 0
            //},
        });

        var selectedShowCode1 = '';
        if (Array.isArray(selectedShow1)) {
            selectedShowCode1 = selectedShow1[0];
        } else {
            selectedShowCode1 = selectedShow1;
        }

        if (selectedShow2.length != []) {
            var selectedShowCode2 = '';
            if (Array.isArray(selectedShow2)) {
                selectedShowCode2 = selectedShow2[0];
            } else {
                selectedShowCode2 = selectedShow2;
            }
        }
        else {
            selectedShowCode2 = 0;
        }

        let postdata = {
            reportName,
            reportOption,
            rptDropDown1Value,
            showcode: selectedShowCode1,
            showcode2: selectedShowCode2
        }

        downloadReportByName(postdata).then(response => {
            //console.log(response);
            //console.log(response.headers['content-disposition']);

            if (response.data) {
                //uses the fileName sent down from API enpoint in response header
                var fileName = response.headers['content-disposition'].replace('filename=', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                //a.download = reportName + ".xlsx";
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                message.destroy(key);
            } else {
                toast.warning("Report is not yet defined");
            }
        });
    }

    function LoadSelectedWidget(widgetId, widgetName) {
        setTimeout(() => props.loadSelectedWidget(widgetId, widgetName), 500);
    }

    function setSelectedShowCode(reportName, reportOption, rptDropDown1Value, selectedShow1, selectedShow2) {
        hideRunReportModal();

        downloadReport(reportName, reportOption, rptDropDown1Value, selectedShow1, selectedShow2);
    }

    return (
        <Drawer
            closeIcon={<i className="fas fa-chevron-left float-left"></i>}
            title='Report/Output'
            placement={'right'}
            onClose={handleClose}
            visible={modalInfo.show}
            key='reportsSlider'
            width={'85%'}
            className="d-flex"
            footer={
                <div className="d-flex justify-content-between">
                    <div>
                        <button className="btn btn-outline-primary float-right" onClick={handleClose}>Close</button>
                    </div>
                </div>
            }
        >
            <div className="row align-items-start mt-3 ml-3 h-100">
                {Object.keys(reportsToDisplay).length > 0 ?
                    <Fragment>
                        {Object.keys(reportsToDisplay).map((key, idx) => {
                            return (
                                <div className="col col-lg-3 col-12" style={{ height: height.value + 'px' }} key={idx} ref={biggestGroup === key ? listRef : null} id="getHeight">
                                    <Card title={key.includes('Exports') ? key : `${key} Reports`} className="d2p-reporting-card">
                                        {reportsToDisplay[key].map((r, idx2) => <p className="a u" key={idx2} value={r.reportId} id={r.reportName} onClick={() => handleReportRequest(r)}>{r.reportName}</p>)}

                                    </Card>
                                </div>
                            );
                        })}
                    </Fragment>
                    :
                    <div>
                        <h2 className="color-primary">Your Profile Is Not Configured For Access To Reporting/Output</h2>
                        <h4>Contact Your System Administrator To Request Access</h4>
                    </div>
                }

                {!height.triggered &&
                    <div className="fixed-white-cover" />
                }
            </div>

            {state.showRunReportModal &&
                <RunReportModal showModal={state.showRunReportModal} hideRunReportModal={hideRunReportModal} setSelectedShowCode={setSelectedShowCode}
                    reportName={selectedReport.reportName} reportId={selectedReport.reportId}
                    option1={selectedReport.option1} option2={selectedReport.option2} option3={selectedReport.option3} dropDown1={selectedReport.dropDown1}
                    chooseTwoShows={selectedReport.chooseTwoShows} />
            }
        </Drawer>
    );
}

export default ReportsSlider;